export default{
    All: 1,
    Open: 2,
    Closed: 3
}